import { useTranslation } from "react-i18next";
import Helmet from "react-helmet";
import ImageHeader from "../../../../components/image-header/image-header";
import generalImg from "../../../../assets/imgs/services/international/general.jpg";
import { useEffect, useState } from "react";
import axios from "axios";
import navBarEn from "../../../../translations/en/navbar.json";
import navBarEs from "../../../../translations/es/navbar.json";

function General() {
  const [tGeneral] = useTranslation("generalPage");
  const [tSMetaData] = useTranslation("metaData");
  const idGeneral = "c4f4cd6a-cc0f-48cc-812c-d4daff768ab5";
  const [textDescription, setTextDescription] = useState("");

  sessionStorage.setItem(
    "routeEs",
    `/${navBarEs["category-services"].services}/${
      Object.keys(navBarEs["products-submenu"])[1]
    }/${Object.keys(navBarEs["products-internacional-submenu"])[1]}`
  );

  sessionStorage.setItem(
    "routeEn",
    `/${navBarEn["category-services"].services}/${
      Object.keys(navBarEn["products-submenu"])[1]
    }/${Object.keys(navBarEn["products-international-submenu"])[1]}`
  );

  useEffect(() => {
    let currentLng = "";
    localStorage.getItem("lng")
      ? (currentLng = `${localStorage.getItem("lng")}`)
      : (currentLng = "es");

    axios
      .get(
        `${process.env.REACT_APP_URL_BACKEND}/api/textWeb/text/${idGeneral}`)
      .then((response) => {
        if (currentLng === "es") {
          setTextDescription(
            response.data.textWeb.text_es["01-descripción"].content
          );
        } else {
          setTextDescription(
            response.data.textWeb.text_us["01-description"].content
          );
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <>
      <Helmet>
        <title>{tSMetaData("general.title")}</title>
        <meta name="description" content={tSMetaData("general.description")} />
      </Helmet>
      <ImageHeader
        section={tGeneral("header.section")}
        title={tGeneral("header.title")}
        description={
          textDescription
            ? JSON.parse(textDescription)
            : JSON.parse(tGeneral("description.content"))
        }
        contactSales={tGeneral("header.contact-sales")}
        contactProductID="btnContactGeneral"
        imgBackground={generalImg}
      />
    </>
  );
}

export default General;
